import { useCallback } from "react";
import { useNow } from "@/lib/elapsed";
import { liveSecondsAt } from "@/lib/multi-view";
import type { ElapsedSource } from "@/lib/elapsed";

/**
 * One clock for every recipe on the screen.
 *
 * The board gives each row its own interval; here a dozen chips, cards and top
 * bars must agree to the second, so the screen ticks once and hands each
 * session its seconds. Anchored on when the list was last fetched (the server's
 * figure is only as old as that), exactly as `useLiveSeconds` is anchored on
 * the figure changing.
 */
export function useSessionClock(fetchedAtMs: number): (session: ElapsedSource) => number {
  const now = useNow(true);
  return useCallback(
    // Before the first fetch there is no anchor, and nothing on screen to tick.
    (session: ElapsedSource) => (fetchedAtMs > 0 ? liveSecondsAt(session, fetchedAtMs, now) : session.elapsedSeconds),
    [fetchedAtMs, now],
  );
}
